export interface IJobDetails  {
    Id?: number;
    JobDefinition?: string;
    Qty?: number;
    JobBreakDownType?: Record<string, any>;
    TotalLatency?: number;
    AverageLatencyByType?: number;
    CompletionStatus?: number;
    JobCuratedCount?: number;
    AverageTransactionForAMinute?: number;
    TotalUniqueUsers?: number;
    StartDate?: string; // You might want to use Date type if you parse it properly
    EndDate?: string; // You might want to use Date type if you parse it properly
    TransactionStartedAt?: string; // You might want to use Date type if you parse it properly
    TransactionEndedAt?: string; // You might want to use Date type if you parse it properly
    DataType?: string;
    Skill?: string;
    RequestedBy?: string;
    JobType?: string;
    ProductId?: string;
    ProductDetails?: string;
    Location?: string;
    Level?: number;
    ContactPerson?: string;
    Deadline?: string; // You might want to use Date type if you parse it properly
    AssignedTo?: string[];    
}

export enum IJobDetailsActionTypes {
    FETCH_JOB_DETAILS_REQUEST = 'FETCH_JOB_DETAILS_LIST_REQUEST',
    FETCH_JOB_DETAILS_SUCCESS = 'FETCH_JOB_DETAILS_SUCCESS',
    FETCH_JOB_DETAILS_FAILURE = 'FETCH_JOB1_DETAILS_FAILURE',

    FETCH_JOB_SOCKET_DETAILS_REQUEST = 'FETCH_JOB_SOCKET_DETAILS_REQUEST',
    FETCH_JOB_SOCKET_DETAILS_SUCCESS = 'FETCH_JOB_SOCKET_DETAILS_SUCCESS',
    FETCH_JOB_SOCKET_DETAILS_FAILURE = 'FETCH_JOB_SOCKET_DETAILS_FAILURE',
}



export type IJobActionCreator = {
    type?: string;
    payload?: IJobDetails;
};
